import { render, staticRenderFns } from "./version-detail.vue?vue&type=template&id=02358cda"
import script from "./version-detail.vue?vue&type=script&lang=js"
export * from "./version-detail.vue?vue&type=script&lang=js"
import style0 from "./version-detail.vue?vue&type=style&index=0&id=02358cda&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports